import { QueryClient } from "@tanstack/react-query";

export const dashboardQueryClient = new QueryClient({
  defaultOptions: {
    // Disable caching globally; individual queries can opt in as needed.
    queries: {
      gcTime: 0,
      staleTime: 0,
    },
  },
});

export const invalidateFoodsAutocompleteQueries = () =>
  dashboardQueryClient.invalidateQueries({
    queryKey: ["foods-autocomplete"],
    exact: false,
  });

export const invalidateMealsQueries = () =>
  dashboardQueryClient.invalidateQueries({
    queryKey: ["meals"],
    exact: false,
  });
